export default __webpack_public_path__ + "static/media/user.d942d73a.svg";